import EmailIcon from "@mui/icons-material/Email";
import { Button, Tooltip } from "@mui/material";
import { UserRank } from "@types_def/models/user.type";
import { useTranslation } from "react-i18next";

import { useBulkSelectionActionVisibility } from "./use-bulk-selection-action-visibility";

export function BulkSendRatingEmailAction() {
  const visible = useBulkSelectionActionVisibility({
    requireAdmin: true,
    minRank: UserRank.MAINTAINER,
  });
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Tooltip title={t("delivery.action.send-rating-email.title")}>
      <span>
        <Button
          color="info"
          disabled
          size="small"
          startIcon={<EmailIcon fontSize="small" />}
          variant="contained"
        >
          {t("delivery.action.send-rating-email.text")}
        </Button>
      </span>
    </Tooltip>
  );
}
